import { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import { request } from '../../../Redux/Sagas/requests/api'
import { primary_color } from '../../../Helper/uiHelper'
import { setNotification } from '../../../Redux/Reducers/notificationHandling'
import { fetchUpdateApiData } from '../../../Redux/Reducers/CMS'

/**
 * Auto-opens when Pupil Premium is opened if the school has abandoned PP preview holds.
 * Clear releases Reserved only; Continue leaves them (cleared overnight).
 */
const PupilPremiumReservedPrompt = ({ onCleared }) => {
  const dispatch = useDispatch()
  const currentRow = useSelector((state) => state.CMS.currentRow)
  const domainId = currentRow?.[0]?.id
  const [open, setOpen] = useState(false)
  const [count, setCount] = useState(0)
  const [releasing, setReleasing] = useState(false)
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    if (!domainId || checked) return

    request('get-pupil-premium-reserved-holds', 'POST', { domain_id: domainId })
      .then((res) => {
        const holdCount = res?.data?.count ?? 0
        setCount(holdCount)
        if ((res?.status === 200 || res?.status === 202) && holdCount > 0) {
          setOpen(true)
        }
      })
      .finally(() => setChecked(true))
  }, [domainId, checked])

  const onContinue = () => {
    setOpen(false)
  }

  const onClear = () => {
    setReleasing(true)
    request('release-pupil-premium-reserved-holds', 'POST', { domain_id: domainId }).then((res) => {
      setReleasing(false)
      if (res?.status === 200 || res?.status === 202) {
        const released = res?.data?.released ?? count
        dispatch(
          setNotification({
            type: 'success',
            message: `${released} reserved Pupil Premium locker${released === 1 ? '' : 's'} cleared.`,
          })
        )
        dispatch(fetchUpdateApiData())
        setOpen(false)
        setCount(0)
        if (typeof onCleared === 'function') onCleared()
      } else {
        dispatch(
          setNotification({
            type: 'error',
            message: res?.data?.message || 'Could not clear reserved lockers.',
          })
        )
      }
    })
  }

  if (!open || count <= 0) return null

  return (
    <Modal
      isOpen={open}
      toggle={onContinue}
      centered
      backdrop='static'
      fade={false}
      zIndex={2000}
      wrapClassName='pp-reserved-modal-wrap'
      modalClassName='pp-reserved-modal'
      contentClassName='pp-reserved-modal-content border-0'>
      <div
        style={{
          background: '#fff',
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0 8px 28px rgba(0, 0, 0, 0.18)',
        }}>
        <ModalHeader toggle={onContinue} className='border-bottom-0'>
          Reserved Pupil Premium lockers
        </ModalHeader>
        <ModalBody>
          <p className='mb-2'>
            This school has <strong>{count}</strong> Pupil Premium locker{count === 1 ? '' : 's'} still reserved from a
            preview that was not saved.
          </p>
          <p className='mb-0'>
            Clear them now, or continue. Anything still reserved will be cleared automatically overnight.
          </p>
        </ModalBody>
        <ModalFooter className='border-top-0'>
          <button
            className='btn rounded-pill border'
            type='button'
            onClick={onContinue}
            disabled={releasing}
            style={{ fontWeight: 700 }}>
            Continue
          </button>
          <button
            className='btn text-white rounded-pill'
            type='button'
            onClick={onClear}
            disabled={releasing}
            style={{ background: primary_color, fontWeight: 700 }}>
            {releasing ? 'Clearing...' : `Clear ${count} reserved`}
          </button>
        </ModalFooter>
      </div>
      <style>{`
        .pp-reserved-modal-wrap .modal-dialog {
          box-shadow: none !important;
          filter: none !important;
        }
        .pp-reserved-modal-content {
          background: transparent !important;
          box-shadow: none !important;
          border: none !important;
        }
        .pp-reserved-modal .modal-content {
          background: transparent !important;
          box-shadow: none !important;
          border: none !important;
        }
      `}</style>
    </Modal>
  )
}

export default PupilPremiumReservedPrompt
